<template>
    <div class="RiskMannFooter">
        <footer v-if="idUsuario" class="fixed-bottom bg-light shadow-sm p-2 rounded">
            <div class="container">
                <div class="d-flex justify-content-evenly">
                    <!-- Botón que abre el menú de empresas -->
                    <a v-if="!esModoSinConexion" href="javascript:void(0)" type="button" @click="abrirEmpresas()">
                        <i class="fas fa-building icono" id="icono-empresas-footer"></i>
                    </a>


                    <a>
                        <label class="fw-bold icono no-cursor">
                            |
                        </label>
                    </a>

                    <!-- Botón a WhatsApp directo de Soporte -->
                    <a :href="enlaceSoporte" target="_blank">
                        <i class="fas fa-headset icono text-danger" id="icono-soporte-footer"></i>
                    </a>

                    <a v-if="!esModoSinConexion">
                        <label class="fw-bold icono no-cursor">
                            |
                        </label>
                    </a>

                    <!-- Botón que abre el menú de acceso directo -->
                    <a href="javascript:void(0)" type="button" @click="abrirAccesoDirecto()">
                        <i class="fas fa-street-view icono" id="icono-accesos-directos-footer"></i>
                    </a>

                    <!-- Mantengo los comentarios originales -->
                    <!-- <router-link v-if="idUsuario" :to="{ name: 'UsuarioCodigoQR' }">
                    <label class="icon qr-code" id="icono-codigo-qr-footer">
                        <ion-icon name="qr-code" class="cursor-pointer"></ion-icon>
                    </label>
                    </router-link> -->
                    <!-- <RegistroManual v-if="idUsuario" /> -->
                    <!-- <router-link :to="{ name: 'SoporteTecnico' }">
                    <label class="icon headset" id="icono-soporte-footer">
                        <ion-icon name="headset" class="cursor-pointer text-danger"></ion-icon>
                    </label>
                    </router-link> -->
                    <!-- <router-link :to="{ name: 'Novedades' }">
                    <label class="icon headset" id="icono-novedades-footer">
                        <ion-icon name="newspaper" class="cursor-pointer"></ion-icon>
                    </label>
                    </router-link> -->
                </div>
                <Empresas v-if="esEmpresas" @mostrar="cerrarEmpresas" />
                <AccesoDirecto v-if="esAccesoDirecto" @mostrar="cerrarAccesoDirecto" />
            </div>
        </footer>
    </div>
</template>

<script>
import { auth } from '@/firebase';
import { Offcanvas } from 'bootstrap';
import localforage from 'localforage';
import Empresas from './Empresas/Empresas.vue';
import AccesoDirecto from './AccesoDirecto.vue';
import { enlaceWhatsappSoporte } from '@/utils/soporte';
// import RegistroManual from './RegistroManual.vue';

export default {
    name: 'RiskMannFooter',

    components: {
        Empresas,
        AccesoDirecto
        // RegistroManual
    },

    data() {
        return {
            // Chat de soporte por WhatsApp (src/utils/soporte.js).
            enlaceSoporte: enlaceWhatsappSoporte(),
            idUsuario: '',
            esEmpresas: false,
            esAccesoDirecto: false,
            esModoSinConexion: false
        };
    },

    async created() {
        this.esModoSinConexion = await this.$store.state.obtenerModoSinConexion();
        if (this.esModoSinConexion) {
            const obtenerUsuario = await localforage.getItem(this.$store.state.colecciones.localforage.usuarios.local);
            if (obtenerUsuario) {
                this.idUsuario = obtenerUsuario.id;
            }
        } else {
            const usuario = auth.currentUser;
            if (usuario) {
                const usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
                if (usuarioDB) {
                    this.idUsuario = usuarioDB.id;
                }
            }
        }
    },

    methods: {
        abrirEmpresas() {
            this.esEmpresas = true;
            setTimeout(() => {
                new Offcanvas(('#empresasFooter'), {
                    backdrop: true,
                }).show();
            }, 25);
        },

        cerrarEmpresas(data) {
            this.esEmpresas = data;
        },

        abrirAccesoDirecto() {
            this.esAccesoDirecto = true;
            setTimeout(() => {
                new Offcanvas(('#accesoDirectoFooter'), {
                    backdrop: true,
                }).show();
            }, 25);
        },

        cerrarAccesoDirecto(data) {
            this.esAccesoDirecto = data;
        },
    },
};
</script>

<style scoped>
footer {
    border: 1px solid rgba(136, 136, 136, 0.2);
}

ion-icon {
    color: #073d7a;
    font-size: 15pt;
}

.icono {
    color: #073d7a;
    font-size: 15pt;
}

.cursor-pointer {
    cursor: pointer;
}

.no-cursor {
    cursor: default;
}
</style>